import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PRODUCT_CATEGORY_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { ProductCategoryComponent } from './product-category/product-category.component';

const routes: Routes = [
  {
    path: PRODUCT_CATEGORY_ROUTE,
    component: ProductCategoryComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductCategoryRoutingModule {}
